import { isUserDTO, TUserDTO } from "@/core/api/model/user.ts";
import { GET } from "@/core/api/client.ts";
import { isBooleanWrapperDTO, TBooleanWrapperDTO } from "@/core/api/model/common.ts";
import { isString } from "@/core/utils/types.ts";

/**
 * Fetches user info data from api
 */
export async function getUser(): Promise<TUserDTO> {
    const { data } = await GET("/user/info", {});
    if (isUserDTO(data)) {
        return data;
    }
    throw new Error("Missing or invalid user info data.");
}

export async function checkIfApiKeyExists(): Promise<TBooleanWrapperDTO> {
    const { data } = await GET("/user/api-key/exists", {});
    if (isBooleanWrapperDTO(data)) {
        return data;
    }
    throw new Error("It could not be verified whether API Key exists");
}

export async function getApiKey() {
    const { data } = await GET("/user/api-key", {
        parseAs: "text",
        headers: {
            Accept: "text/plain",
        },
    });
    if (isString(data)) {
        return data;
    }
    throw new Error("Api Key could not be retrieved");
}
